import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	/**
	 * @param {*} params
	 */
	findAll (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/product/payments', {
				params: params
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/product/payment.js